define('responsive-gameday/views/Monitor/ViewModels/distributors/PitchFXViewDistributor',['require','exports','module','jquery','GameDayCore','GameDayCore/GDModel/enums/datasources/Datasources','message-service/message-service','../../Events/ViewModelUpdateEvents','gameday-resource-path/gameday-resource-path','Responsive/util/imageDensity','extant/extant'],function(require,exports,module) {

    var $ = require("jquery"),
        GDC = require("GameDayCore"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources"),
        MessageService = require("message-service/message-service"),
        UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        imageDensity = require( 'Responsive/util/imageDensity' ),
        exists = require("extant/extant");

    var dataPack = {},
        gameData;

    function getStadiumImages(view){
        var detail = imageDensity.choose(view, '','','@2x');
        return {
            defaultTop : resourcePath.get('stadiumTop',{ 
                density : detail,
                phase   : this.dayOrNight
            }),
            top : resourcePath.get('stadiumTop',{ 
                density : detail,
                phase   : this.dayOrNight, 
                id      : this.stadium.id
            }),
            bottom : resourcePath.get('stadiumBottom',{ 
                density : detail
            })
        }
    }

    exports.setGameData = function(game, scenes) {
        gameData = game || GDC.getGameData();
        this.prepareForDispatch();
        MessageService.off(UpdateEvents.REQUEST_PITCHFX_DATA,exports.handleUpdateRequest);
        MessageService.on.call(this,UpdateEvents.REQUEST_PITCHFX_DATA,exports.handleUpdateRequest);
    };

    exports.prepareForDispatch = function(){
        var atbat = gameData.play && gameData.play.atbat;

        // console.warn("face",payload)
        dataPack = {
            gamepk  : gameData.linescore.game_pk,
            oldTimey    : (gameData.linescore.time_date || "1955").split('/')[0] < 1955,
            atbat   : (atbat || {}),
            hotcoldzone : gameData.hotcoldzone,
            stadium     : (gameData.game && gameData.game.stadium || gameData.linescore && gameData.linescore.venue_id),
            dayOrNight  : gameData.game && gameData.game.day_or_night,
            hasPitchFX  : gameData.linescore && gameData.linescore.gameday_sw !== "N",
            getStadiumImages : getStadiumImages
        };
        MessageService.publish(UpdateEvents.UPDATE_PITCHFX, dataPack);
    };

    exports.handleUpdateRequest = function() {
        gameData = GDC.getGameData();
        this.prepareForDispatch();
    }
});
